var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00838F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_308_6568",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0013,
    cy: 20,
    r: 17.3333,
    fill: "url(#paint0_linear_308_6568)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_308_6568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1606 6.56264C19.7122 6.61635 5.73389 15.9889 5.65332 16.2736C5.57275 16.5609 5.54053 19.5473 5.54053 19.5473L7.34253 20.1193L7.35059 22.4933L8.3147 24.4672V32.8112L7.59497 34.3822L5.62109 34.965V36.3776L4.07422 36.8476C4.07422 36.8476 4.0957 38.0587 4.0957 38.2602C4.0957 38.4616 4.16284 38.8886 4.97119 38.8886C5.77954 38.8886 35.283 38.7516 35.5811 38.7516C35.8792 38.7516 36.188 38.6925 36.2041 38.1581C36.2202 37.6237 36.188 36.869 36.188 36.869L34.6895 36.1278L34.6841 34.9435L32.2456 34.1915L31.6575 32.5265L31.6655 24.682L32.6001 22.7108L32.8821 22.1764V20.0548L34.4531 19.4613C34.4531 19.4613 34.4827 16.3917 34.437 16.3031C34.3967 16.2172 20.5312 6.51967 20.1606 6.56264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.7722 22.8879L12.7739 22.8852L13.5581 24.7678L13.4856 32.5182L12.833 34.2746L11.6675 34.2773L11.0256 32.529L10.9961 24.7516L11.7722 22.8879ZM17.1057 22.861L16.1094 24.7248L16.1846 32.5182L16.7754 34.2612L23.2825 34.2343L23.8679 32.5182L23.884 24.7087L23.124 22.8315L17.1057 22.861ZM27.3376 22.8127L28.2212 22.8073L29.0027 24.6899L29 32.5209L28.5461 34.2182L27.0718 34.2209L26.6206 32.5209L26.5857 24.6979L27.3376 22.8127Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8735 33.1469L31.6587 32.5185L8.30786 32.5131L8.1333 33.2141L31.8735 33.1469ZM8.03931 23.8952L32.0105 23.9785L31.6667 24.6821L8.31592 24.7707L8.03931 23.8952ZM5.53906 19.5473L34.4543 19.4614C34.4543 19.4614 34.4731 19.738 34.4543 19.8535C34.4382 19.9689 34.2878 20.071 33.9038 20.071H33.5198C33.5198 20.071 6.45215 20.2053 6.15137 20.2053C5.85059 20.2053 5.63574 20.0388 5.58472 19.9045C5.55518 19.8159 5.53906 19.5473 5.53906 19.5473Z",
    fill: "#CDDFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 34.2587V28.2834L22.7109 28.3344L22.7217 34.2426L17.4688 34.2587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 28.0121L19.7891 34.2506L20.3315 34.2479V28.1034L19.7917 28.0121Z",
    fill: "#A5D0D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 28.5679V27.0694H22.7109V28.5679C22.7109 28.5679 17.5144 28.5223 17.4688 28.5679Z",
    fill: "#BAC4CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4692 27.0693H22.7113C22.7113 27.0693 22.7328 26.602 22.2467 26.5563C21.7607 26.5107 18.1889 26.5483 17.8881 26.5563C17.4396 26.5697 17.4692 27.0693 17.4692 27.0693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9667 9.45234C16.7874 9.47234 14.2708 12.0187 14.3783 15.2383C14.4858 18.4579 17.4018 20.7221 19.9667 20.7021C22.6588 20.6821 25.4936 18.7312 25.6208 15.2205C25.7503 11.7121 22.8322 9.43234 19.9667 9.45234Z",
    fill: "#CDDFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9859 10.2235C17.3245 10.2413 15.194 12.4521 15.284 15.2562C15.3718 18.0603 17.7151 19.8379 19.8631 19.8579C22.3402 19.8801 24.6199 18.2403 24.7252 15.1851C24.8305 12.1299 22.3841 10.2079 19.9859 10.2235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 12.6342C19.3862 12.6342 19.3513 11.9859 19.3942 11.9304C19.437 11.875 19.6117 11.875 19.95 11.875C20.2898 11.875 20.4279 11.875 20.4803 11.9204C20.5327 11.9657 20.5057 12.6745 20.5057 12.6745C20.5057 12.6745 20.9662 12.8576 21.2537 13.0928C21.5586 13.3414 21.7761 13.6723 21.7586 13.7277C21.7412 13.7832 21.133 14.3442 21.0456 14.3257C20.9583 14.3072 20.4629 13.6941 19.8721 13.6538C18.9337 13.59 18.9416 14.3627 19.5244 14.5743C20.1072 14.7859 21.9444 14.9539 21.873 16.5009C21.8126 17.8027 20.5693 17.8951 20.5693 17.8951C20.5693 17.8951 20.6042 18.3822 20.5693 18.4108C20.5343 18.4393 19.4386 18.4561 19.4037 18.4024C19.3688 18.3486 19.3958 17.8497 19.3958 17.8497C19.3958 17.8497 18.9083 17.7489 18.5081 17.4634C18.1079 17.1778 17.8205 16.8016 17.8126 16.7546C17.8046 16.7092 18.5176 16.0743 18.5684 16.0558C18.6192 16.0373 19.3449 16.7932 20.0294 16.8553C20.7249 16.9192 21.0202 16.1935 20.0548 15.8811C19.0893 15.5687 17.9507 15.3016 18.0031 14.0234C18.0555 12.7249 19.3862 12.6342 19.3862 12.6342Z",
    fill: "#00838F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_6568",
    x1: 20.0013,
    y1: 2.66669,
    x2: 20.0013,
    y2: 37.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D30D0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ach.8e92b20f2ec6737de99b7e203ec1912b.svg";
export { ForwardRef as ReactComponent };